import React from 'react';

import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../utils/localStorage';
import Banner from '../Banner/Banner.jsx';
import { HeaderDesktop, HeaderMobile } from '../Common/const';
import Avatar from './Avatar.jsx';
import CommonHeaderMobile from './CommonHeaderMobile.jsx';
import NotificationIcon from './NotificationIcon.jsx';
import Notifications from './Notifications.jsx';

class CommonHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      level: 3,
      collapse: false,
      hidePopUp: this.props.hidePopUp,
      userActive: this.props.user.active,
      showUserMenu: false,
      showNotificationTop: false,
    };
  }

  componentDidMount() {
    this.props.getFriendRequestNotifications();
  }

  // toggles collapse between opened and closed (true/false)
  showNotificationRedDot = () => {
    this.setState({
      hasAlert: true,
    });
  };

  hideNotificationRedDot = () => {
    this.setState({
      hasAlert: false,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.id) {
      const location = this.props.location.pathname;
      if (nextProps.user.active === false && !nextProps.user.isFreeAccount) {
        if (
          location.includes('study') ||
          location.includes('account-settings') ||
          location.includes('dashboard')
        ) {
          const alreadyClosed = getLocalStorageItem('top-notification-closed');
          if (!alreadyClosed) {
            this.openNotificationTop(true);
          }
        } else {
          this.openNotificationTop(false);
        }
      } else {
        this.openNotificationTop(false);
      }

      if (nextProps.loadNotifications && !this.props.loadNotifications) {
        this.props.getNotificationsMessages(nextProps.user.id);
      }
    }
  }

  checkAccountExpire = () => {
    if (this.props.user.active === false) {
      if (this.state.hidePopUp === false) {
        return true;
      }
      return false;
    }
    return false;
  };

  getAvatar = () => {
    if (this.props.user && this.props.user.imgUrl) {
      return this.props.user.imgUrl;
    }
    return '';
  };

  openNotificationMenu = () => {
    this.setState({
      showNotificationMenu: !this.state.showNotificationMenu,
      showUserMenu: false,
    });
  };

  openUserMenu = () => {
    this.setState({
      showNotificationMenu: false,
      showUserMenu: !this.state.showUserMenu,
    });
  };

  openNotificationTop = (value) => {
    this.setState({ showNotificationTop: value });
    if (!value) {
      setLocalStorageItem('top-notification-closed', true, 86400000);
    }
  };

  buttonSubscriptionType = () => {
    if (this.props.user.stripeId) {
      return '/app/manage-subscription';
    }
    return '/app/account-settings';
  };

  render() {
    const title = 'Your subscription has expired.';
    const subtitle = 'For full study access, renew your subscription.';
    const buttonText = 'MANAGE YOUR SUBSCRIPTION';
    const buttonLink = this.buttonSubscriptionType();
    const avatarSrc = this.getAvatar();
    return (
      <>
        <Notifications
          title={title}
          subtitle={subtitle}
          buttonText={buttonText}
          buttonLink={buttonLink}
          hidePopUp={this.state.hidePopUp}
          checkAccountExpire={this.checkAccountExpire}
          showNotificationTop={this.state.showNotificationTop}
          closeNotificationTop={this.openNotificationTop}
        />
        <HeaderMobile>
          <CommonHeaderMobile
            userSubscription={this.props.userSubscription}
            user={this.props.user}
            history={this.props.history}
            userName={this.props.user.name + this.props.user.lastName}
            setShowMobileMenu={this.props.setShowMobileMenu}
            userNotifications={this.props.userNotifications}
            notificationByFriend={this.props.notificationByFriend}
            userNotificationsSeen={this.props.userNotificationsSeen}
            resolveFriendRequest={this.props.resolveFriendRequest}
            setResolveFriendRequestMessage={
              this.props.setResolveFriendRequestMessage
            }
            setResolveFriendRequestSuccess={
              this.props.setResolveFriendRequestSuccess
            }
            resolveFriendRequestWaiting={this.props.resolveFriendRequestWaiting}
            resolveFriendRequestMessage={this.props.resolveFriendRequestMessage}
            resolveFriendRequestSuccess={this.props.resolveFriendRequestSuccess}
            activateSubscription={this.props.activateSubscription}
            subscriptionActivationSucces={
              this.props.subscriptionActivationSucces
            }
            subscriptionActivationWaiting={
              this.props.subscriptionActivationWaiting
            }
            subscriptionActivationMessage={
              this.props.subscriptionActivationMessage
            }
          />
          {(window &&
            window.location &&
            (window.location.href.includes('/question/') ||
              window.location.href.includes('/study'))) ||
          window.location.href.includes('/education-center') ? null : (
            <Banner bannersActive={this.props.bannersActive} />
          )}
        </HeaderMobile>
        <HeaderDesktop>
          <div className="d-flex flex-row m-0 justify-content-end common-header align-items-start">
            {(window &&
              window.location &&
              (window.location.href.includes('/question/') ||
                window.location.href.includes('/study'))) ||
            window.location.href.includes('/education-center') ? null : (
              <Banner bannersActive={this.props.bannersActive} />
            )}
            <NotificationIcon
              hasAlert={
                this.props.userNotifications.length +
                  this.props.notificationByFriend.length >
                0
              }
              openNotificationMenu={this.openNotificationMenu}
              showNotificationMenu={this.state.showNotificationMenu}
              userNotifications={this.props.userNotifications}
              userNotificationsSeen={this.props.userNotificationsSeen}
              notificationsMessagesSeen={this.props.notificationsMessagesSeen}
              user={this.props.user}
              resolveFriendRequest={this.props.resolveFriendRequest}
              setResolveFriendRequestMessage={
                this.props.setResolveFriendRequestMessage
              }
              setResolveFriendRequestSuccess={
                this.props.setResolveFriendRequestSuccess
              }
              resolveFriendRequestWaiting={
                this.props.resolveFriendRequestWaiting
              }
              resolveFriendRequestMessage={
                this.props.resolveFriendRequestMessage
              }
              resolveFriendRequestSuccess={
                this.props.resolveFriendRequestSuccess
              }
              notificationByFriend={this.props.notificationByFriend}
              getFriendRequestNotifications={
                this.props.getFriendRequestNotifications
              }
            />
            <Avatar
              openUserMenu={this.openUserMenu}
              showUserMenu={this.state.showUserMenu}
              avatarSrc={avatarSrc}
              level={this.state.level}
              user={this.props.user}
              info={this.props.dashboardHeaderInfo}
              waiting={this.props.dashboardHeaderInfoWaiting}
            />
          </div>
        </HeaderDesktop>
      </>
    );
  }
}

export default CommonHeader;
